import { Spin, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { crmBrandName } from '../../branding/crmBrand';

const apiBase = (import.meta.env.VITE_API_BASE_URL ?? '/api/v1').replace(/\/$/, '');

type Props = {
  /** e.g. `public/contact-us` */
  publicPath: string;
  pageTitle: string;
};

export default function PublicHtmlPage({ publicPath, pageTitle }: Props) {
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = `${pageTitle} · ${crmBrandName}`;
    let cancelled = false;
    void (async () => {
      try {
        const res = await fetch(`${apiBase}/${publicPath}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = (await res.json()) as { html?: string };
        if (!cancelled) setHtml(data.html?.trim() || '');
      } catch {
        if (!cancelled) setError('無法載入內容，請稍後再試。');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [publicPath, pageTitle]);

  if (error) {
    return (
      <div style={{ maxWidth: 720, margin: '48px auto', padding: 24 }}>
        <Typography.Title level={3}>{pageTitle}</Typography.Title>
        <Typography.Text type="danger">{error}</Typography.Text>
      </div>
    );
  }

  if (html === null) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!html) {
    return (
      <div style={{ maxWidth: 720, margin: '48px auto', padding: 24 }}>
        <Typography.Title level={3}>{pageTitle}</Typography.Title>
        <Typography.Paragraph type="secondary">內容尚未設定。</Typography.Paragraph>
      </div>
    );
  }

  return (
    <iframe
      title={pageTitle}
      srcDoc={html}
      style={{ border: 'none', width: '100%', minHeight: '100vh', display: 'block' }}
      sandbox="allow-same-origin"
    />
  );
}
